import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit, OnChanges {
  @Input() control!: FormControl;
  @Input() submitted: boolean = false;
  @Input() items: any[] = [];
  @Input() labelProperty: string = "";
  @Input() valueProperty: string = "";
  @Input() placeholder: string = "";
  @Input() errorMessage: string = "";
  @Input() reset: boolean = true; // New input property
  @Input() append: string = ""
  @Output() change = new EventEmitter<any>(); // Add this line

  itemsToDisplay: any[] = [];

  ngOnInit() {
    this.updateItems();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] || changes['reset']) {
      this.updateItems();
    }
  }

  updateItems() {
    if (this.reset) {
      this.itemsToDisplay = [{ [this.labelProperty]: this.placeholder, [this.valueProperty]: null }, ...this.items];
    } else {
      this.itemsToDisplay = [...this.items];
    }
  }

  onValueChange(selectedItem: any): void {
    if (this.reset && selectedItem[this.valueProperty] === null) {
      this.control.reset();
    }
    this.change.emit(selectedItem); // Emit the change event
  }
}
